<template>
   <span>
       <button class="ui tiny icon button" :class="selectedOptions.length == 0 ? 'basic' : 'inverted blue'" title="Tags bearbeiten" @mousedown.prevent="toggleMenu()">
          <i class="ui tag icon"></i>
       </button>
       <div class="ui vertical hover menu" :style="{display: showMenu ? 'block' : 'none'}">
         <div class="item">
            <div class="ui icon input">
              <input ref="addTagInput" type="text" placeholder="Neuer Tag" @blur="toggleMenu(false)" >
              <i class="add link icon" @mousedown.prevent="addTag($refs.addTagInput.value.trim()); $refs.addTagInput.value = '';"></i>
            </div>
         </div>
         <a class="item" :class="{selected: selected}" v-for="(selected, option) in uniqueOptions" :key="option" @mousedown.prevent="addTag(option)">
            <i v-if="selected" class="ui tag icon"></i>
            {{ option }}
         </a>
       </div>
   </span>
</template>

<script>

    export default {
        name: 'TagsSelect',
        props: ['options', 'selectedOptions'],
        data: function () {
          return {
            showMenu: false
          }
        },
        computed: {
            uniqueOptions: function() {
                let optionMap = {};

                for(let option of this.options)
                {
                    optionMap[option] = this.selectedOptions.indexOf(option) !== -1;
                }

                return optionMap;
            }
        },
        methods: {
            toggleMenu(value) {
                if(value == undefined) {
                  value = !this.showMenu;
                }

                this.showMenu = value;

                if(value) {
                    this.$nextTick(() => {
                        this.$refs.addTagInput.focus();
                    });
                }
            },
            addTag(clickedOption) {

                if(clickedOption == null || clickedOption.length == 0) {
                    return;
                }

                let newSelectedOptions = [];

                for(let option in this.uniqueOptions)
                {
                    if(clickedOption === option ? !this.uniqueOptions[option] : this.uniqueOptions[option]) {
                        newSelectedOptions.push(option);
                    }
                }

                if(this.uniqueOptions[clickedOption] == null) {
                    newSelectedOptions.push(clickedOption);
                }

                this.emitSelection(newSelectedOptions, clickedOption);
            },
            emitSelection(items, selectedItem) {
                this.$emit('select', items, selectedItem);
            }
        }
    }
</script>

<style scoped>
   .hover {
      position: absolute !important;
      max-width: 400px;
      width: auto !important;
      z-index: 10;
      max-height: 300px;
      overflow-y: scroll;
      overflow-x: hidden;
   }
   .menu > .selected.item {
      font-weight: bold ;
   }
</style>
